import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, MapPin, Clock, Briefcase, Music, Users } from "lucide-react";
const Careers = () => {
  const navigate = useNavigate();
  const jobs = [{
    title: "Talent Manager",
    department: "Creator Management",
    location: "Johannesburg, SA",
    type: "Full-time",
    icon: Users,
    description: "Lead and grow our roster of DJs, MCs, photographers, and creative professionals across Africa.",
    requirements: ["3+ years experience in talent management or artist relations", "Strong network within the African entertainment industry", "Excellent negotiation and communication skills", "Experience with booking systems and contract management", "Ability to scout and develop emerging talent", "Understanding of the local music and events scene"]
  }, {
    title: "Producer / Composer",
    department: "Creative",
    location: "Remote / Johannesburg",
    type: "Contract",
    icon: Music,
    description: "Create original music, soundscapes, and compositions for platform content, marketing, and special projects.",
    requirements: ["Proven portfolio of music production and composition", "Proficiency in DAWs like Ableton Live, FL Studio, or Logic Pro", "Ability to produce across various genres (Amapiano, Afro-house, Gqom)", "Experience with sound design and audio engineering", "Collaborative spirit and ability to work on tight deadlines"]
  }];
  return <div className="container mx-auto p-4 sm:p-6 md:p-8">
      
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold tracking-tight">Join Our Team</h1>
        <p className="text-muted-foreground mt-2 text-lg">Help us build the future of entertainment in Africa.</p>
      </div>
      <div className="grid gap-6 lg:grid-cols-2 text-primary">
        {jobs.map((job, index) => <Card key={index} className="flex flex-col">
            <CardHeader>
              <div className="flex items-start justify-between">
                <div>
                  <CardTitle className="text-2xl font-bold">{job.title}</CardTitle>
                  <div className="flex items-center flex-wrap gap-x-4 gap-y-2 text-sm text-muted-foreground mt-2">
                    <div className="flex items-center"><Briefcase className="mr-1.5 h-4 w-4" />{job.department}</div>
                    <div className="flex items-center"><MapPin className="mr-1.5 h-4 w-4" />{job.location}</div>
                    <div className="flex items-center"><Clock className="mr-1.5 h-4 w-4" />{job.type}</div>
                  </div>
                </div>
                <job.icon className="h-10 w-10 text-primary" />
              </div>
            </CardHeader>
            <CardContent className="flex-grow">
              <p className="mb-4">{job.description}</p>
              <h4 className="font-semibold mb-2">What you'll need:</h4>
              <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
                {job.requirements.map((req, i) => <li key={i}>{req}</li>)}
              </ul>
            </CardContent>
            <div className="p-6 pt-0">
               <Button className="w-full">Apply Now</Button>
            </div>
          </Card>)}
      </div>
    </div>;
};
export default Careers;